import {createAction, props} from "@ngrx/store";
import {IRevisione, MyVerbale} from "../models/interfaces/revisione.interface";
import {IDatiBusiness} from "../models/interfaces/dati-business.interface";
import {FormControlStatus} from "@angular/forms";
import { ILocalSaveData } from "../models/interfaces/local-remote-last-save.interface";

export abstract class Revisione53CoreActions {

  static hydrateRevisione = createAction(
    '[App Initializer] Carica Revisione nello store',
    props<{revisione: IRevisione}>()
  )

  static hydrateDatiBusiness = createAction(
    '[App Initializer] Carica Dati Business nello store',
    props<{datiBusiness: IDatiBusiness}>()
  )

  static updateMyVerbale = createAction(
    '[Form Page] Aggiorna MyVerbale',
    props<{my_Verbale: MyVerbale}>()
  )

  static updateMyVerbaleFromListener = createAction(
    '[Form Listener] Aggiorna MyVerbale',
    props<{callback: (myVerbale: MyVerbale) => MyVerbale}>()
  )

  static updateRevisione = createAction(
    '[Form Listener] Aggiorna Revisione',
    props<{revisione: IRevisione}>()
  )

  static hydraterevisione53 = createAction(
    '[revisione53 Init Effect] Hydrate revisione53'
  )

  static revisione53hydrated = createAction(
    '[revisione53 Init Effect] Hydrated revisione53',
    props<{revisione: IRevisione, datiBusiness: IDatiBusiness}>()
  )

  static statusInviaVerbale = createAction(
    '[Form] Status BTN Invia verbale',
    props<{status: FormControlStatus}>()
  )

  static updateDataUltSalvataggio = createAction(
    '[Pulsante salva su server] Update data ultimo salvataggio'
  )

  static autosaveDataUltSalvataggio = createAction(
    '[Autosave ogni 5 minuti] Update data ultimo salvataggio'
  )

  static updateDataUltSalvataggioAndMd5 = createAction(
      '[revisione53 Dopo salva su server] updateDataUltSalvataggioAndMd5',
      props<{localSaveData: ILocalSaveData}>()
  )

  static clearRevisione = createAction(
    '[Revisione53] Clear store'
  )
}
